import {useState} from 'react';


const useSidebar = (isOpened: boolean = false) => {
    const [isOpenSidebar, setIsOpenSidebar] = useState<boolean>(isOpened);

    const toggleSidebar = (): void => {
        setIsOpenSidebar(!isOpenSidebar);
    };

    return {
        isOpenSidebar,
        toggleSidebar
    }
};

export default useSidebar;
